/* src/@fuse/components/theme-options/theme-options.component.scss */
@keyframes rotating {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
fuse-theme-options {
  display: flex;
  overflow: hidden;
}
fuse-theme-options .theme-options-panel {
  display: flex;
  flex-direction: column;
  flex: 1 0 auto;
  padding: 40px 24px 24px 24px;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}
fuse-theme-options .theme-options-panel .header {
  display: flex;
  flex: 0 1 auto;
  margin-bottom: 32px;
  align-items: center;
  justify-content: space-between;
}
fuse-theme-options .theme-options-panel .header .title {
  font-size: 20px;
  font-weight: 600;
  padding-left: 4px;
}
fuse-theme-options .theme-options-panel form {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
}
fuse-theme-options .theme-options-panel form .group {
  display: flex;
  flex: 1 0 auto;
  flex-direction: column;
  position: relative;
  border-radius: 2px;
  padding: 28px 16px 8px 16px;
  margin: 16px 0;
}
fuse-theme-options .theme-options-panel form .group h2 {
  position: absolute;
  top: -11px;
  left: 8px;
  margin: 0;
  padding: 0 8px;
  font-size: 16px;
  font-weight: 600;
}
fuse-theme-options .theme-options-panel form .group h3 {
  font-size: 14px;
  font-weight: 600;
  margin: 24px 0 16px 0;
  padding: 0;
}
fuse-theme-options .theme-options-panel form .group h3:first-of-type {
  margin-top: 0;
}
/*# sourceMappingURL=data:application/json;base64,ewogICJ2ZXJzaW9uIjogMywKICAic291cmNlcyI6IFsic3JjL0BmdXNlL2NvbXBvbmVudHMvdGhlbWUtb3B0aW9ucy90aGVtZS1vcHRpb25zLmNvbXBvbmVudC5zY3NzIl0sCiAgInNvdXJjZXNDb250ZW50IjogWyJAdXNlICdAZnVzZS9zY3NzL3BhcnRpYWxzL2JyZWFrcG9pbnRzLnNjc3MnIGFzIGJyZWFrcG9pbnRzO1xuXG5Aa2V5ZnJhbWVzIHJvdGF0aW5nIHtcbiAgICBmcm9tIHtcbiAgICAgICAgdHJhbnNmb3JtOiByb3RhdGUoMGRlZyk7XG4gICAgfVxuICAgIHRvIHtcbiAgICAgICAgdHJhbnNmb3JtOiByb3RhdGUoMzYwZGVnKTtcbiAgICB9XG59XG5cbmZ1c2UtdGhlbWUtb3B0aW9ucyB7XG4gICAgZGlzcGxheTogZmxleDtcbiAgICBvdmVyZmxvdzogaGlkZGVuO1xuXG4gICAgLnRoZW1lLW9wdGlvbnMtcGFuZWwge1xuICAgICAgICBkaXNwbGF5OiBmbGV4O1xuICAgICAgICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICAgICAgICBmbGV4OiAxIDAgYXV0bztcbiAgICAgICAgcGFkZGluZzogNDBweCAyNHB4IDI0cHggMjRweDtcbiAgICAgICAgb3ZlcmZsb3c6IGF1dG87XG4gICAgICAgIC13ZWJraXQtb3ZlcmZsb3ctc2Nyb2xsaW5nOiB0b3VjaDtcblxuICAgICAgICAuaGVhZGVyIHtcbiAgICAgICAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgICAgICAgICBmbGV4OiAwIDEgYXV0bztcbiAgICAgICAgICAgIG1hcmdpbi1ib3R0b206IDMycHg7XG4gICAgICAgICAgICBhbGlnbi1pdGVtczogY2VudGVyO1xuICAgICAgICAgICAganVzdGlmeS1jb250ZW50OiBzcGFjZS1iZXR3ZWVuO1xuXG4gICAgICAgICAgICAudGl0bGUge1xuICAgICAgICAgICAgICAgIGZvbnQtc2l6ZTogMjBweDtcbiAgICAgICAgICAgICAgICBmb250LXdlaWdodDogNjAwO1xuICAgICAgICAgICAgICAgIHBhZGRpbmctbGVmdDogNHB4O1xuICAgICAgICAgICAgfVxuICAgICAgICB9XG5cbiAgICAgICAgZm9ybSB7XG4gICAgICAgICAgICBkaXNwbGF5OiBmbGV4O1xuICAgICAgICAgICAgZmxleDogMSAxIGF1dG87XG4gICAgICAgICAgICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuXG4gICAgICAgICAgICAuZ3JvdXAge1xuICAgICAgICAgICAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgICAgICAgICAgICAgZmxleDogMSAwIGF1dG87XG4gICAgICAgICAgICAgICAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbiAgICAgICAgICAgICAgICBwb3NpdGlvbjogcmVsYXRpdmU7XG4gICAgICAgICAgICAgICAgYm9yZGVyLXJhZGl1czogMnB4O1xuICAgICAgICAgICAgICAgIHBhZGRpbmc6IDI4cHggMTZweCA4cHggMTZweDtcbiAgICAgICAgICAgICAgICBtYXJnaW46IDE2cHggMDtcblxuICAgICAgICAgICAgICAgIGgyIHtcbiAgICAgICAgICAgICAgICAgICAgcG9zaXRpb246IGFic29sdXRlO1xuICAgICAgICAgICAgICAgICAgICB0b3A6IC0xMXB4O1xuICAgICAgICAgICAgICAgICAgICBsZWZ0OiA4cHg7XG4gICAgICAgICAgICAgICAgICAgIG1hcmdpbjogMDtcbiAgICAgICAgICAgICAgICAgICAgcGFkZGluZzogMCA4cHg7XG4gICAgICAgICAgICAgICAgICAgIGZvbnQtc2l6ZTogMTZweDtcbiAgICAgICAgICAgICAgICAgICAgZm9udC13ZWlnaHQ6IDYwMDtcbiAgICAgICAgICAgICAgICB9XG5cbiAgICAgICAgICAgICAgICBoMyB7XG4gICAgICAgICAgICAgICAgICAgIGZvbnQtc2l6ZTogMTRweDtcbiAgICAgICAgICAgICAgICAgICAgZm9udC13ZWlnaHQ6IDYwMDtcbiAgICAgICAgICAgICAgICAgICAgbWFyZ2luOiAyNHB4IDAgMTZweCAwO1xuICAgICAgICAgICAgICAgICAgICBwYWRkaW5nOiAwO1xuXG4gICAgICAgICAgICAgICAgICAgICY6Zmlyc3Qtb2YtdHlwZSB7XG4gICAgICAgICAgICAgICAgICAgICAgICBtYXJnaW4tdG9wOiAwO1xuICAgICAgICAgICAgICAgICAgICB9XG4gICAgICAgICAgICAgICAgfVxuICAgICAgICAgICAgfVxuICAgICAgICB9XG4gICAgfVxufVxuIl0sCiAgIm1hcHBpbmdzIjogIjtBQUVBLFdBQUE7QUFDSTtBQUNJLGVBQUEsT0FBQTs7QUFFSjtBQUNJLGVBQUEsT0FBQTs7O0FBSVI7QUFDSSxXQUFBO0FBQ0EsWUFBQTs7QUFFQSxtQkFBQSxDQUFBO0FBQ0ksV0FBQTtBQUNBLGtCQUFBO0FBQ0EsUUFBQSxFQUFBLEVBQUE7QUFDQSxXQUFBLEtBQUEsS0FBQSxLQUFBO0FBQ0EsWUFBQTtBQUNBLDhCQUFBOztBQUVBLG1CQUFBLENBUkosb0JBUUksQ0FBQTtBQUNJLFdBQUE7QUFDQSxRQUFBLEVBQUEsRUFBQTtBQUNBLGlCQUFBO0FBQ0EsZUFBQTtBQUNBLG1CQUFBOztBQUVBLG1CQUFBLENBZlIsb0JBZVEsQ0FQSixPQU9JLENBQUE7QUFDSSxhQUFBO0FBQ0EsZUFBQTtBQUNBLGdCQUFBOztBQUlSLG1CQUFBLENBdEJKLG9CQXNCSTtBQUNJLFdBQUE7QUFDQSxRQUFBLEVBQUEsRUFBQTtBQUNBLGtCQUFBOztBQUVBLG1CQUFBLENBM0JSLG9CQTJCUSxLQUFBLENBQUE7QUFDSSxXQUFBO0FBQ0EsUUFBQSxFQUFBLEVBQUE7QUFDQSxrQkFBQTtBQUNBLFlBQUE7QUFDQSxpQkFBQTtBQUNBLFdBQUEsS0FBQSxLQUFBLElBQUE7QUFDQSxVQUFBLEtBQUE7O0FBRUEsbUJBQUEsQ0FwQ1osb0JBb0NZLEtBQUEsQ0FUSixNQVNJO0FBQ0ksWUFBQTtBQUNBLE9BQUE7QUFDQSxRQUFBO0FBQ0EsVUFBQTtBQUNBLFdBQUEsRUFBQTtBQUNBLGFBQUE7QUFDQSxlQUFBOztBQUdKLG1CQUFBLENBOUNaLG9CQThDWSxLQUFBLENBbkJKLE1BbUJJO0FBQ0ksYUFBQTtBQUNBLGVBQUE7QUFDQSxVQUFBLEtBQUEsRUFBQSxLQUFBO0FBQ0EsV0FBQTs7QUFFQSxtQkFBQSxDQXBEaEIsb0JBb0RnQixLQUFBLENBekJSLE1BeUJRLEVBQUE7QUFDSSxjQUFBOzsiLAogICJuYW1lcyI6IFtdCn0K */
